const AVALIACAO_RESPOSTA_TIPO = {
  MUL: { id: 'MUL', descricao: 'Multipla escolha' },
  NUM: { id: 'NUM', descricao: 'Numérica' },
  DIC: { id: 'DIC', descricao: 'Dicotômica' }
};

export default AVALIACAO_RESPOSTA_TIPO;
